'use strict';

var React = require('react');

var SvgTransactionFeeEuroMajor = function SvgTransactionFeeEuroMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13a1 1 0 0 1 0 2c-2.206 0-4-1.794-4-4v-7h-1.184a2.997 2.997 0 0 1-2.816 2c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368a2.997 2.997 0 0 1 2.816-2c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2h-5.185v7c0 1.103.897 2 2 2zm3.014.992c-.011-.333-.006-.667.014-1h-.278a.75.75 0 1 1 0-1.5h.49c.456-2.024 1.567-3.492 3.086-3.492 1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5h-1.232a8.24 8.24 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5h-1.042c.272 1.102.749 1.812 1.119 1.812h.073c.313 0 .426 0 .496-.054a.45.45 0 0 0 .106-.152l.004-.007a.993.993 0 0 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796h-.426a.75.75 0 1 1 0-1.5h.265z"
  }));
};

exports.SvgTransactionFeeEuroMajor = SvgTransactionFeeEuroMajor;
